import { styled, Tab } from '@mui/material';
import { Tabs } from '@mui/material';
import Heading from 'components/Heading';
import PageContainer from 'components/PageContainer';
import PageContent from 'components/PageContent';
import PageSection from 'components/PageSection';
import Spacing from 'components/Spacing';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import GeneralInformation from './GeneralInformation';
import WhitelabellingSettings from './WhitelabellingSettings';
import InvestorPortalSettings from './InvestorPortalSettings';
import BankAccountSettings from './BankAccountSettings';

const InvestmentFirmAddEditScreen = () => {
  const { id } = useParams<{ id?: string }>();

  enum FirmTabs {
    General,
    WhiteLabelling,
    PortalAndKYC,
    BankAccounts,
  }

  const PageContentStyled = styled(PageContent)({
    overflow: 'visible',
  });

  const [activeTab, setActiveTab] = useState(FirmTabs.General);

  const handleTabChange = (_: unknown, selectedTab: FirmTabs) => {
    setActiveTab(selectedTab);
  };

  const isCreatePage = !id;

  const breadcrumbs = [
    { label: 'Dashboard' },
    { label: 'Firms', link: '/firm' },
    {
      label: id ? 'Update Firm' : 'Add Firm',
      link: '/',
      isActive: true,
    },
  ];

  return (
    <PageContainer
      heading={isCreatePage ? 'Add Firm' : 'Firm: Firm Details'}
      breadcrumbs={breadcrumbs}
    >
      <PageContentStyled>
        <Spacing size="lg">
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            showDivider
            variant="scrollable"
          >
            <Tab
              value={FirmTabs.General}
              label={
                <Heading variant="h5" noMargin>
                  General
                </Heading>
              }
            />
            <Tab
              value={FirmTabs.WhiteLabelling}
              disabled={isCreatePage}
              label={
                <Heading variant="h5" noMargin>
                  White-labelling
                </Heading>
              }
            />
            <Tab
              value={FirmTabs.PortalAndKYC}
              disabled={isCreatePage}
              label={
                <Heading variant="h5" noMargin>
                  Portal and KYC
                </Heading>
              }
            />
            <Tab
              value={FirmTabs.BankAccounts}
              disabled={isCreatePage}
              label={
                <Heading variant="h5" noMargin>
                  Bank accounts
                </Heading>
              }
            />
          </Tabs>
          <PageSection>
            {activeTab === FirmTabs.General && <GeneralInformation />}
            {activeTab === FirmTabs.WhiteLabelling && (
              <WhitelabellingSettings />
            )}
            {activeTab === FirmTabs.PortalAndKYC && <InvestorPortalSettings />}
            {activeTab === FirmTabs.BankAccounts && <BankAccountSettings />}
          </PageSection>
        </Spacing>
      </PageContentStyled>
    </PageContainer>
  );
};

export default InvestmentFirmAddEditScreen;
